module.exports = __webpack_public_path__ + "static/media/image5.582ce7ba.jpeg";